import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { SendMessage } from './SendMessage';
import { ReceiveMessages } from './ReceiveMessages';
import { ReplayMessages } from './ReplayMessages';
import { BrowseMessages } from './BrowseMessages';
import { Delete, Visibility, Send, Replay, List } from '@mui/icons-material';
import { useMediaQuery } from "@mui/material";


const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const TabPanelContainer = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

const TabPanelBox = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(3),
}));


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      style={{ display: value === index ? 'block' : 'none' }}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <TabPanelContainer >
        <TabPanelBox>
          {children}
        </TabPanelBox>
      </TabPanelContainer> 
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


export default function EntityMessageManager(props) {
  const { setErrorMessage, isLicenced } = props;
  const theme = useTheme();
  const [value, setValue] = useState(props.entityInfo.entityType === "topic" ? "send" : "browse");
  const isNotLargeScreen = useMediaQuery(theme => theme.breakpoints.down("lg"));

  useEffect(() => {
    setValue(props.entityInfo.entityType === "topic" ? "send" : "browse");
  }
  , [ props.entityInfo.entityType ]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Root>
      <AppBar position="static" color="default">
        <Tabs
          scrollButtons
          allowScrollButtonsMobile
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant={isNotLargeScreen ? "scrollable" : "fullWidth"}
          aria-label="Messages Toolbar"
        >
          <Tab
            sx={{ display: props.entityInfo.entityType === "topic" ? "none" : "flex" }}
            label="Browse"
            icon={<List />}
            {...tabProps(0)}
            value="browse"
          />
          <Tab
            sx={{ display: props.entityInfo.entityType === "subscription" ? "none" : "flex" }}
            label="Send"
            icon={<Send />}
            {...tabProps(1)}
            value="send"
          />
          <Tab
            sx={{ display: props.entityInfo.entityType === "topic" ? "none" : "flex" }}
            label="Peek"
            icon={<Visibility />}
            {...tabProps(2)}
            value="peek"
          />
          <Tab
            sx={{ display: props.entityInfo.entityType === "topic" ? "none" : "flex" }}
            label="Receive"
            icon={<Delete />}
            {...tabProps(3)}
            value="receive"
          />
          <Tab
            sx={{ display: props.entityInfo.entityType === "topic" ? "none" : "flex" }}
            label="Replay"
            icon={<Replay />}
            {...tabProps(4)}
            value="replay"
          />
        </Tabs>
      </AppBar>
      
      <TabPanel value={value} index="send" dir={theme.direction}>
        <SendMessage 
          entityInfo={props.entityInfo} 
          credentials={props.credentials} 
          onMessageEventReceived={props.onMessageEventReceived} 
          selectedEntity={props.selectedEntity} 
          setErrorMessage={setErrorMessage}
          isLicenced={isLicenced}
        />
      </TabPanel> 
      
      <TabPanel value={value} index="browse" dir={theme.direction}>
        <BrowseMessages 
          entityInfo={props.entityInfo} 
          credentials={props.credentials} 
          selectedEntity={props.selectedEntity} 
          setErrorMessage={setErrorMessage}
          isLicenced={isLicenced}
          onMessageSelected={props.onMessageSelected}
          isDisplayed={value === "browse"}
          onMessageEventReceived={props.onMessageEventReceived}
        />
      </TabPanel> 
      
      <TabPanel value={value} index="peek" dir={theme.direction}>
        <ReceiveMessages 
          receiveMode="peekLock"
          entityInfo={props.entityInfo} 
          credentials={props.credentials} 
          onMessageEventReceived={props.onMessageEventReceived} 
          selectedEntity={props.selectedEntity} 
          setErrorMessage={setErrorMessage}
        />
      </TabPanel>
      
      <TabPanel value={value} index="receive" dir={theme.direction}>
        <ReceiveMessages 
          receiveMode="receiveAndDelete"
          entityInfo={props.entityInfo} 
          credentials={props.credentials} 
          onMessageEventReceived={props.onMessageEventReceived} 
          selectedEntity={props.selectedEntity} 
          setErrorMessage={setErrorMessage}
        />
      </TabPanel>
      
      <TabPanel value={value} index="replay" dir={theme.direction}>
        <ReplayMessages 
          entityInfo={props.entityInfo} 
          credentials={props.credentials} 
          onMessageEventReceived={props.onMessageEventReceived} 
          selectedEntity={props.selectedEntity} 
          setErrorMessage={setErrorMessage}
        />
      </TabPanel>
    </Root>
  );
}